import { render, staticRenderFns } from "./index.vue?vue&type=template&id=204b84a5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=204b84a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b84a5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiBreadcrumb: require('/var/www/html/intelli.com.br/components/base/ui/Breadcrumb.vue').default,AuthPasswordForgot: require('/var/www/html/intelli.com.br/components/auth/PasswordForgot.vue').default,AuthRegister: require('/var/www/html/intelli.com.br/components/auth/Register.vue').default})
